// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#userback_button_container .userback-button-sw[wstyle=text_icon]{left:50%;margin-left:-50px}", ""]);
// Exports
module.exports = exports;
